import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App.jsx";

import { Provider } from "react-redux";
import store from "./redux/store";
import NewTabWrapper from "./components/DynamicTabs/NewTabWrapper.jsx";
import { AudioPlayerGroup } from "./components";

createRoot(document.getElementById("root")).render(
  // <StrictMode>
  //   <App />
  // </StrictMode>,
  <Provider store={store}>
    <NewTabWrapper>
      <AudioPlayerGroup>
        <App />
      </AudioPlayerGroup>
    </NewTabWrapper>
  </Provider>,
);
